<template>
    <div>
        <user-content v-if="operation.description && !hideDescription" :text="operation.description" class="mb-16"/>

        <description-list class="mb-16">
            <slot/>
			<description-list-item v-if="operation.start_date || operation.end_date" :title="$t('label.operation_time')">
				<template #text>
					<dynamic-date-range :start="operation.start_date" :end="operation.end_date" time>
					</dynamic-date-range>
				</template>
			</description-list-item>
            <description-list-item v-if="operation.is_remote || operation.full_address" :title="$t('label.operation_location')" :text="operation.full_address ?? $t('label.remote')"/>
            <description-list-item v-if="operation.lat && operation.lng && assignment && assignment.distance_to_job" :title="$t('label.distance_to_operation_location')"
                                   :text="`${Math.round(assignment.distance_to_job / 1000)} km`" :help="$t('help.approx_distance_by_air_distance')"/>
            <div v-if="(operation.lat && operation.lng) && operation.city" class="min-h-240 mt-16">
                <client-only>
                    <map-map :center="[operation.lat, operation.lng]" :zoom="13" class="min-h-240" rounded>
                        <map-marker :title="$t('label.operation_location')"
                                    :lat-lng="[operation.lat, operation.lng]"
                                    :content="{title: $t('label.operation_location')}"/>
                    </map-map>
                </client-only>
            </div>
        </description-list>
    </div>
</template>

<script>
export default {
    name: "PositionOperationContent",

    props: {

        // The position or position operation model that holds the operation info
        operation: {
            type: Object,
            required: true
        },

        // The user job model that hold's user specific assignment data
        assignment: {
            type: Object,
            default: null
        },

        hideDescription: {
            type: Boolean,
            default: false
        }
    }
}
</script>
